export default {
  label: {
    title: 'Convidar usuários',
    paginationTitle: 'Usuários com acesso',
    description: 'Para adicionar mais de um e-mail, separe-os por vírgula. Os e-mails adicionados aparecerão na lista abaixo.',
    input: 'Adicione um ou mais e-mails',
  },
  hint: {
    emptyEmail: 'Insira um e-mail válido.',
    duplicateEmail: 'E-mail incorreto.',
  },
  button: {
    addUser: 'Adicionar',
  },
  notification: {
    loadingData: 'Carregando dados...',
  },
};
